import {keyBy} from "lodash";
import {PoolTabsType, PositionType} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getPlayersStore = (store: IStore) => store.players;
export const getPlayers = (store: IStore) => store.players.players;

export const getPlayerByIdSelector = createSelector(
	[getPlayers],
	(players) => (id: number) => players[id]
);

export const getPlayersByType = createSelector(
	[getPlayersStore],
	({players, poolPlayers}) =>
		(type: PoolTabsType) => {
			const playerIds = poolPlayers[type];

			return playerIds
				.map((playerId) => players[playerId])
				.filter(
					(player) => player.position !== PositionType.Pitcher || player.isPitcherHitter
				);
		}
);

export const getSuggestedPlayersByRoundId = createSelector(
	[getPlayersStore],
	(store) => (roundId: number) => {
		return keyBy(
			store.suggestedPlayers.filter((it) => it.roundId === roundId),
			"playerId"
		);
	}
);

export const getIsSuggestedPlayer = createSelector(
	[getSuggestedPlayersByRoundId],
	(playersSelector) => (roundId: number, playerId: number) => {
		const players = playersSelector(roundId);
		return !!players[playerId];
	}
);
